import React from "react";
import { CtaButton } from "./CtaButton";
import { images } from "../data/images";
import { useLocalizedPrices } from "../hooks/useLocalizedPrices";
export function FinalCtaSection() {
  const {
    mainPrice
  } = useLocalizedPrices();
  return <section className="relative isolate overflow-hidden bg-cocoa-950 text-cream-100" data-id="element-105" data-mp="3quay5ah40lcc">
      <img src={images.homeKitchen} alt="" className="absolute inset-0 -z-10 h-full w-full object-cover opacity-30" data-id="element-106" data-mp="3vs44q4mbrhd5" />
      <div className="absolute inset-0 -z-10 bg-cocoa-950/60" aria-hidden="true" data-id="element-107" data-mp="2y2ranedhcl4j" />
      <div className="mx-auto max-w-3xl px-5 pb-28 pt-16 text-center sm:py-32" data-id="element-108" data-mp="334glou0pcysm">
        <h2 className="font-display text-4xl font-semibold leading-tight text-cream-50 sm:text-6xl" data-id="element-109" data-mp="3820b8q2uoxzv">
          Imagina tu cocina con <em className="font-medium text-caramel-400" data-id="element-110" data-mp="3cv2w89tkaz4g">cajas listas para entregar</em>
        </h2>
        <p className="mx-auto mt-6 max-w-2xl text-lg leading-relaxed text-cream-200" data-id="element-111" data-mp="2fe46cy34nzs0">
          Tus recetas ya hacen feliz a tu familia y a tus amigos. El próximo paso no es cocinar mejor: es animarte a ordenarlo todo y mostrarlo. Dentro de 30 días puedes seguir pensando “algún día”, o tener tu emprendimiento armado y abierto a recibir pedidos.
        </p>
        <div className="mt-10 flex justify-center" data-id="element-112" data-mp="23lf64k5y747z">
          <CtaButton label="Quiero empezar hoy" data-id="element-113" data-mp="23k40eesxzme8" />
        </div>
        <p className="mt-4 text-sm text-cream-300" data-id="element-114" data-mp="1ym2hbtvinn2r">6 volúmenes + 4 bonos · Pago único de {mainPrice}</p>
      </div>
    </section>;
}